"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
var _locales = require("../../utils/locales");
const messages = exports.messages = {
  [_locales.locales.en]: {
    info: "Extra info icon",
    validate: "Validation met icon",
    required: "(required)"
  },
  [_locales.locales.es]: {
    info: "Icono de información adicional",
    validate: "Icono de validación cumplida",
    required: "(requerido)"
  },
  [_locales.locales.fr]: {
    info: "Icône d'informations supplémentaires",
    validate: "Icône de validation rencontrée",
    required: "(obligatoire)"
  },
  [_locales.locales.pt]: {
    info: "Ícone de informação extra",
    validate: "Ícone de validação",
    required: "(requeridos)"
  },
  [_locales.locales.zh]: {
    info: "額外信息圖標",
    validate: "驗證滿足圖標",
    required: "(必需的)"
  },
  [_locales.locales.de]: {
    info: "Zusätzliche Info-Ikone",
    validate: "Validierung erfüllt Ikone",
    required: "(erforderlich)"
  },
  [_locales.locales.it]: {
    info: "Icona info extra",
    validate: "Icona validazione soddisfatta",
    required: "(obbligatorio)"
  },
  [_locales.locales.ja]: {
    info: "追加情報アイコン",
    validate: "バリデーション完了アイコン",
    required: "(必須)"
  },
  [_locales.locales.tl]: {
    info: "Karagdagang icon info",
    validate: "Natutugunan icon ng pagpapatunay",
    required: "(kailangan)"
  },
  [_locales.locales.hi]: {
    info: "अतिरिक्त जानकारी आइकन",
    validate: "सत्यापन पूरा आइकन",
    required: "(आवश्यक)"
  },
  [_locales.locales.ko]: {
    info: "추가 정보 아이콘",
    validate: "검증 완료 아이콘",
    required: "(필수)"
  }
};